import { extendZodWithOpenApi } from '@anatine/zod-openapi';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import {
  AiApiSpec_generateNoteQueueRequestBodySchema,
  AiApiSpec_noteStyleSchema,
} from '../../models/ai/models.ai_engine_api_spec_reexported';
import { GenericTimelyAccountId, OKGeneric } from '../../models/models.generic';

extendZodWithOpenApi(z);
const c = initContract();

export const apiAiNotesRoute = c.router({
  requestHourNoteGeneration: {
    method: 'POST',
    path: `/1.0/ai/generate_note/hour`,
    summary: 'Request asynchronous note generation for an hour/draft',
    description:
      'Queues an asynchronous AI-powered note generation request for a specific hour or draft entry. The AI analyzes the time entry context and generates a descriptive note based on associated activities and patterns.',
    body: AiApiSpec_generateNoteQueueRequestBodySchema.omit({
      timely_user_id: true,
      tic_user_id: true,
    }),
    responses: {
      200: OKGeneric,
    },
  },
  requestSuggestionNoteGeneration: {
    method: 'POST',
    path: `/1.0/ai/generate_note/suggestion`,
    summary: 'Request note generation for one or multiple suggestions',
    description:
      'Generates AI-powered notes for one or more AI suggestion entries. Accepts a single suggestion ID or an array of suggestion IDs, and applies the specified note style (defaults to "all" styles). Useful for batch note generation on multiple suggestions.',
    body: z.object({
      style: AiApiSpec_noteStyleSchema.optional().default('all'),
      suggestion_ids: z.union([z.string().uuid(), z.array(z.string().uuid())]),
      timely_account_id: GenericTimelyAccountId,
    }),
    responses: {
      200: OKGeneric,
    },
  },
});
